import { LeadcontactPropertyEstimationDto } from '../estimation/domain/models/leadcontact-property-estimation.dto';

export default class Utils {
  static resolveValuationDisplayCondition(dto: LeadcontactPropertyEstimationDto): boolean {
    const { marketingType, usergroup } = dto;
    return !(marketingType === 'SELL' && (usergroup === 'OWNER' || usergroup === 'BROKER'));
  }
}
